module.exports = __webpack_public_path__ + "static/media/poll2x.ab830c2e.png";